import { Skeleton } from 'primereact/skeleton'

export function createLoadingComponent(loadingComponent?: JSX.Element) {
  if (loadingComponent) {
    return loadingComponent
  }
  return <Skeleton height="37px"></Skeleton> // 37px is the height for inputs
}
